import { colors, fonts } from '../../theme';

const styles = {
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    px: 2,
    py: 1.5,
    borderBottom: `1px solid ${colors.borderSoft}`,
  },
  rowNew: {
    backgroundColor: colors.rowHover,
  },
  rowClickable: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: colors.hoverItem,
    },
  },
  // Avatar, logo and network badge: 36px, pushed down by 4px so the eye lands under the title.
  avatar: {
    width: 36,
    height: 36,
    mt: '4px',
    flexShrink: 0,
    cursor: 'pointer',
  },
  logo: {
    width: 36,
    height: 36,
    mt: '4px',
    flexShrink: 0,
    borderRadius: '50%',
    border: `1px solid ${colors.surfaceHover}`,
    backgroundColor: colors.background,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logoImg: {
    width: 20,
  },
  texts: {
    flexGrow: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 0.25,
  },
  // Like the app: who or what on the first line, what happened under it, the time at its end.
  name: {
    fontFamily: fonts.text,
    fontSize: 13,
    lineHeight: '18px',
    fontWeight: 700,
    color: colors.text,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  text: {
    fontFamily: fonts.text,
    fontSize: 13,
    lineHeight: '18px',
    color: colors.textLight,
    overflowWrap: 'anywhere',
  },
  when: {
    ml: 0.75,
    fontSize: 11.5,
    color: colors.textSubtle,
    whiteSpace: 'nowrap',
  },
  // Square like the avatars' box, the middle of the 9:16 frame.
  thumb: {
    width: 40,
    height: 40,
    borderRadius: '8px',
    objectFit: 'cover',
    flexShrink: 0,
    backgroundColor: colors.surfaceRaised,
  },
  // Round like the avatars, the logo of the network inside.
  brand: {
    width: 36,
    height: 36,
    mt: '4px',
    flexShrink: 0,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${colors.surfaceHover}`,
    backgroundColor: colors.background,
    color: colors.text,
    fontSize: 16,
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: colors.danger,
    flexShrink: 0,
  },
};

export default styles;
